import React, { useState } from "react";
import { OfferModel } from "../models/OfferModel";
import ViewSystemContentComp from "./ViewSystemContentComp";
import { useReferenceDataContext } from "../context/ReferenceDataContext";

interface OfferTermsCompProps {
  offer: OfferModel;
  onAccept: (offer: OfferModel) => void;
  buttonLabel?: string;
}

const OfferTermsComp: React.FC<OfferTermsCompProps> = ({
  offer,
  onAccept,
  buttonLabel = "Accept & View the offer",
}) => {
  
  const { commissionTerms } = useReferenceDataContext();
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleAccept = () => {
    if (!checked) {
      setError("You must agree to the terms and conditions to proceed.");
      return;
    }
    setError("");
    onAccept(offer);
  };

  return (
    <>
      <div className="d-flex flex-row align-items-center justify-content-between w-100">
        {/* Left side: checkbox + label + error */}
        <div className="d-flex flex-column">
          <div className="d-flex align-items-center">
            <input
              className={`form-check-input ${error ? "is-invalid" : ""}`}
              type="checkbox"
              id={`termsCheck-${offer.offerId}`}
              checked={checked}
              onChange={(e) => {
                setChecked(e.target.checked);
                if (e.target.checked) setError("");
              }}
            />
            <label
              className="form-check-label ms-2 mb-0"
              htmlFor={`termsCheck-${offer.offerId}`}
            >
              I agree to the commission fee
              <a
                href="#"
                className={`ms-1 ${error ? "text-danger" : "text-muted text-decoration-underline"}`}
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true);
                }}
              >
                Terms and Conditions
              </a>{" "}
              to proceed.
            </label>
          </div>

          {error && (
            <div className="invalid-feedback d-block mt-1">{error}</div>
          )}
        </div>

        {/* Right side: button */}
        <button
          className="btn btn-sm btn-dark rounded-0"
          onClick={handleAccept}
        >
          {buttonLabel}
        </button>
      </div>

      {/* Modal */}
      {commissionTerms && (
        <ViewSystemContentComp
          show={showModal}
          systemContent={commissionTerms}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default OfferTermsComp;
